// extracted by mini-css-extract-plugin
module.exports = {"arrowWrapper":"PageBtns_arrowWrapper__3ZtUA","arrowWrapper-left":"PageBtns_arrowWrapper-left__3_AQ2"};